import { INDUSTRIES, INDUSTRY_LABEL, INDUSTRY_MSG, type Industry, type Product } from "@genbaryoku/contract";
import type { CSSProperties, ReactNode } from "react";
import { Field } from "./ui.jsx";

/**
 * 業種を選ぶ欄（#142 段4、docs/52 §5）。会員登録・新しい会社・業種の1枚・自社情報で同じ部品。
 * 選べるのはその製品の業種だけ（現場力＝工務店・電気・塗装・設備、営業力＝制作・デザイン…その他）。
 * 会社を作る画面ははじめから製品の既定（DEFAULT_INDUSTRY）が選ばれた形。自社情報で業種が無い会社は「—」から
 */
export function IndustrySelect({
  id,
  product,
  value,
  onChange,
  disabled,
  allowEmpty = false,
  help,
  hint,
  style,
}: {
  id: string;
  product: Product;
  value: Industry | null;
  onChange: (v: Industry) => void;
  disabled?: boolean;
  /** まだ業種が無い（今ある会社）ときの「—」 */
  allowEmpty?: boolean;
  help?: ReactNode;
  hint?: ReactNode;
  style?: CSSProperties;
}) {
  return (
    <Field id={id} label={INDUSTRY_MSG.label} {...(help ? { help } : {})} {...(hint ? { hint } : {})} {...(style ? { style } : {})}>
      <select id={id} className="inp" value={value ?? ""} disabled={disabled} onChange={(e) => e.target.value && onChange(e.target.value as Industry)} data-testid="industry-select">
        {allowEmpty && !value ? <option value="">—</option> : null}
        {INDUSTRIES[product].map((k) => (
          <option key={k} value={k}>
            {INDUSTRY_LABEL[k]}
          </option>
        ))}
      </select>
    </Field>
  );
}
